import { sendElastic } from 'actionCreators/judasLog';
import { cleanUserProfile } from 'actionCreators/user';
import { get, post, put } from 'services/api';
import { IUserToken } from 'interface/user';
import UAParser from 'ua-parser-js';
import { getUrlParams, hjTagging } from 'utils';
import { v4 } from 'uuid';
import { fetchCourse } from './course';
import { API_V4_BASE_URL } from 'settings';
import { resolveErrorStatus } from './error';
import { IAuth } from 'interface/auth';

export const receiveLogin = (user: IUserToken) => ({
  type: 'RECEIVE_LOGIN',
  token: user.token,
  refreshToken: user.refresh_token,
});

const receiveLoginError = (err: any) => ({
  type: 'RECEIVE_LOGIN_ERROR',
  err,
});

export const requestLogin = (creds: any, courseHash?: string) => async (dispatch: any) => {
  dispatch({
    type: 'REQUEST_LOGIN',
  });

  if (!creds.username || !creds.password) {
    dispatch(receiveLoginError({}));
  }
  try {
    const response = await post({
      url: '/oauth/token',
      data: { ...creds, ...getDeviceInfo(), course_hash: courseHash },
    });

    dispatch(receiveLogin(response.data.data));
    dispatch(fetchCourse(courseHash, true));
  } catch (error) {
    hjTagging('ERRO-LOGIN');
    dispatch(receiveLoginError(error.response.data));
    throw error;
  }
};

export const requestLoginAccounts = (token: string, courseHash: string) => async (dispatch: any) => {
  if (!token) {
    dispatch(receiveLoginError({}));
  }
  try {
    const response = await post({
      url: '/oauth/eduzzaccount/validate',
      withCredentials: true,
      baseURL: API_V4_BASE_URL,
      data: { token, ...getDeviceInfo(), course_hash: courseHash },
    });
    dispatch(receiveLogin(response.data.data));
    dispatch(fetchCourse(courseHash, true));
    sendElastic('login', 'Entrou no sistema');
  } catch (error) {
    hjTagging('ERRO-LOGIN');
    dispatch({ type: 'LOGOUT' });
    throw error;
  }
};

export const logout = (redirectTo?: string) => async (dispatch: any, getState: Function) => {
  const state = getState();
  const subdomain = state && state.template && state.template.base && state.template.base.subdomain;
  const base = subdomain ? '' : '/v3';
  redirectTo = redirectTo ? `${base}${redirectTo}` : null;
  sendElastic('logout', 'Saiu do sistema');
  dispatch(cleanUserProfile());
  dispatch({ type: 'LOGOUT', redirectTo });
};

export function getDeviceInfo(): { device_id: string; device_name: string } {
  const params = getUrlParams();

  let deviceId = params.device_id || localStorage.getItem('deviceId');
  let deviceName = params.device_name || localStorage.getItem('deviceName');

  if (!deviceId) {
    deviceId = v4();
    localStorage.setItem('deviceId', deviceId);
  }

  if (!deviceName) {
    const parser = new UAParser();
    const {
      browser: { name: browser },
      os: { name: device },
    } = parser.getResult();

    deviceName = `${browser} - ${device}`;
  }

  localStorage.setItem('deviceId', deviceId);
  localStorage.setItem('deviceName', deviceName);

  return {
    device_id: deviceId,
    device_name: deviceName,
  };
}

const receiveTenantError = (error: number) => ({
  type: 'RECEIVE_TENANT_ERROR',
  error,
});

const requestTenant = () => ({
  type: 'REQUEST_TENANT',
});

const receiveTenant = (id: any, token: string) => ({
  type: 'RECEIVE_TENANT',
  id,
  token,
});

export const loginAsTenant = (producer: number) => async (dispatch: any, getState: Function) => {
  const state = getState();
  const auth: IAuth = state.auth;
  try {
    dispatch(requestTenant());
    const res = await post({
      url: `/oauth/change-user-by-tenantid/${producer}`,
      headers: {
        RefreshToken: auth.refreshToken,
      },
    });
    const token = res.data.data;
    dispatch(receiveTenant(producer, token));
  } catch (error) {
    dispatch(receiveTenantError(resolveErrorStatus(error)));
  }
};
